module.exports = __webpack_public_path__ + "media/images/check-80d619c29fb1d9ec63435feaf6846297.svg";